import PropTypes from 'prop-types'
import React, { useCallback, useEffect, useState } from 'react'
import { useDropzone } from 'react-dropzone'

import { toastErrorLog } from '../../../helpers/toastErrorLog'
import * as tiendasOficialesService from '../../servicios/tiendasOficialesService'

const Upload = ({ idTiendaOficial, imagenPath, esBanner, idAdjunto, setFormData }) => {
  const [cargando, setCargando] = useState(false)
  const [preview, setPreview] = useState(null)
  const [nombreArchivo, setNombreArchivo] = useState('')
  const [adjunto, setAdjunto] = useState(null)

  const obtenerAdjunto = () => {
    if (!idAdjunto) return

    let cancelled = false
    let url = null

    tiendasOficialesService
      .buscarImagenPorAdjunto(idTiendaOficial, idAdjunto)
      .then(({ data }) => {
        if (cancelled) return
        url = URL.createObjectURL(data)
        setAdjunto(url)
      })
      .catch((error) => {
        if (!cancelled) {
          toastErrorLog(error, 'Ocurrió un error al obtener el adjunto.', 'adjunto')
        }
      })

    return () => {
      cancelled = true
      if (url) URL.revokeObjectURL(url)
      setAdjunto(null)
    }
  }

  useEffect(() => {
    obtenerAdjunto()
  }, [idAdjunto, idTiendaOficial])

  useEffect(() => {
    return () => {
      if (preview) URL.revokeObjectURL(preview)
    }
  }, [preview])

  const onDrop = useCallback(
    async (acceptedFiles) => {
      if (acceptedFiles.length === 0) {
        return
      }

      const archivo = acceptedFiles[0]
      const objectUrl = URL.createObjectURL(archivo)
      setPreview(objectUrl)
      setNombreArchivo(archivo.name)
      setCargando(true)
      try {
        const formData = new FormData()
        formData.append('nombre', archivo.name)
        formData.append('idTiendaOficial', idTiendaOficial)
        formData.append('archivo', archivo)
        formData.append('esBanner', esBanner)

        setFormData((prev) => {
          const prevArray = Array.isArray(prev) ? prev : []
          return [...prevArray.filter((fd) => fd.get('esBanner') !== String(esBanner)), formData]
        })
      } catch (error) {
        toastErrorLog(error, 'Ocurrió un error al guardar el archivo.', 'adjunto')
        setPreview(null)
        setNombreArchivo('')
      } finally {
        setCargando(false)
      }
    },
    [idTiendaOficial, esBanner]
  )

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: { 'image/*': [] },
    multiple: false,
    disabled: cargando
  })

  const srcImagen = preview || adjunto || (idAdjunto ? null : imagenPath)

  return (
    <>
      <div className="borde-hormiga text-center" {...getRootProps()}>
        <i className="fa fa-camera fa-2x" aria-hidden="true" />
        <input {...getInputProps()} />
        {cargando ? (
          <p>Subiendo...</p>
        ) : isDragActive ? (
          <p>Soltá la imagen acá...</p>
        ) : srcImagen ? (
          <p>Arrastrá o seleccioná una imagen para reemplazar la actual</p>
        ) : (
          <p>Agregá la imagen desde tu computadora o arrastrala acá</p>
        )}
      </div>
      {srcImagen && (
        <div className="cont-img-subida mb-2">
          <img alt={esBanner ? 'banner' : 'logo'} src={srcImagen} className="subida-img" />
          {nombreArchivo && <p className="subida-img-nombre text-truncate">{nombreArchivo}</p>}
        </div>
      )}
    </>
  )
}

Upload.propTypes = {
  idTiendaOficial: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  imagenPath: PropTypes.string,
  esBanner: PropTypes.bool.isRequired,
  idAdjunto: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setFormData: PropTypes.func.isRequired
}

export default React.memo(Upload)
